import smoothScroll from 'smoothscroll-polyfill';
// import "core-js/modules/es";

smoothScroll.polyfill();
